export const buildSubmitParams = ({
  name,
  email,
  timezone,
  firstName,
  lastName,
  password,
  groupId,
  recaptchaToken,
  hubSpotHutk
}) => ({
  name,
  timezone,
  users: [
    {
      email,
      firstName,
      lastName,
      password
    }
  ],
  ...(groupId && groupId !== "1" && { group: `/api/v2/groups/${groupId}` }), // don't send groupId for endavo main domain and group
  recaptchaToken,
  hubSpotHutk
});
